import React from 'react';

import { Grid } from '@material-ui/core';

import { ButtonInputAdorment } from './styles';

import { TypographyCN } from 'components/atoms/Typograph';

type AdornmentProps = {
  label: string;
  icon: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  width?: string;
} & React.ComponentPropsWithoutRef<typeof ButtonInputAdorment>;

export function InputAdornmentIcon({ label, icon, ...rest }: AdornmentProps) {
  return (
    <Grid container item xs={12} alignItems="center" direction="row" wrap="nowrap">
      <TypographyCN
        fontType="Roboto"
        variant="subtitle2"
        style={{
          fontSize: 18,
          textDecoration: 'underline',
          color: '#A0A0A0',
          width: '100%',
          cursor: 'pointer',
        }}
        text={label}
      />
      <ButtonInputAdorment focusRipple {...rest}>
        {icon}
      </ButtonInputAdorment>
    </Grid>
  );
}
